import React, { useState } from 'react';
import SatInput from '@components/common/satUI/SatInput';
import SatModal from '@components/common/satUI/SatModal';

const InputCoverageDetail = ({ value = '', onChange }) => {
  const {
    isOn: isShowModal,
    on: showModal,
    off: hideModal,
  } = $hooks.useToggler();
  const [details, setDetails] = useState(value.split(' / '));

  const handleDelete = () => {
    setDetails('');
    onChange('');
  };

  const handleChange = (index, value) => {
    const newDetails = [...details];
    newDetails[index] = value;
    setDetails(newDetails);

    const [faceAmount, premium, coverage] = newDetails;
    const faceAmountValue = faceAmount
      ? `${$utils.formatPrice(faceAmount)} 만원`
      : '-';
    const premiumValue = premium ? `${$utils.formatPrice(premium)} 만원` : '-';
    const coverageValue = coverage ?? '-';

    const detailValue = $utils.escapeLineBreak(
      `${faceAmountValue} / ${premiumValue} <br> ${coverageValue}`,
    );
    onChange(detailValue);
  };

  return (
    <>
      <SatInput
        noFocus
        type="html"
        value={$utils.unescapeLineBreak(value)}
        onClick={showModal}
        onDelete={handleDelete}
      />

      <SatModal isPortal visible={isShowModal} setVisible={hideModal}>
        <header className="modal-header">
          <h3 className="layer-tit2">보험가입금액/보험금액/보장내용</h3>
        </header>

        <button
          type="button"
          className="btn-layer-close modal-close"
          onClick={hideModal}
        >
          닫기
        </button>

        <div className="cont">
          <ul className="dot-type type-m">
            <li>보험가입금액/보험금액/보장내용을 입력하시기 바랍니다.</li>
          </ul>
          <div className="insu-box">
            <div className="txt-question mgt-10">
              <p className="tit-mini">보험가입금액</p>
            </div>
          </div>

          <div className="amount">
            <SatInput
              type="currency"
              currencyType="W"
              dataIndex="faceAmount"
              value={$utils.formatPrice(details[0] ?? '')}
              outerSuffix={() => <span className="txt">만원</span>}
              onChange={value => handleChange(0, value)}
            />
          </div>

          <div className="insu-box">
            <div className="txt-question mgt-10">
              <p className="tit-mini">보험금액</p>
            </div>
          </div>

          <div className="amount">
            <SatInput
              type="currency"
              currencyType="W"
              dataIndex="faceAmount"
              value={$utils.formatPrice(details[1] ?? '')}
              outerSuffix={() => <span className="txt">만원</span>}
              onChange={value => handleChange(1, value)}
            />
          </div>

          <div className="insu-box">
            <div className="txt-question mgt-10">
              <p className="tit-mini">보장내용</p>
            </div>
          </div>

          <SatInput
            noSuffix
            type="text"
            value={details[2]}
            onChange={value => handleChange(2, value)}
          />

          {/* <div className="input-wrap u-line">
            <div className="input-area">
              <input
                className="input line1"
                type="text"
                defaultValue
                placeholder
              />
            </div>
          </div> */}
        </div>

        <div className="layer-footer">
          <button
            type="button"
            className="btn-s blue btn-wide modal-close"
            onClick={hideModal}
          >
            저장
          </button>
        </div>
      </SatModal>
    </>
  );
};

export default InputCoverageDetail;
